import { gql } from '@apollo/client';

export const READ_PARKING_SPACE_AVAILABILITY = gql`
  query ReadParkingSpaceAvailabilityV2($input: PmcAvailabilityInput!) {
    readParkingSpaceAvailabilityV2(input: $input) {
      content {
        parkingSpaceUid
        pmcIdRef
        parkingSpaceStatus
        parkingSpace {
          reserved
          name
          type
          uid
          externalNote
          blocked
        }
      }
    }
  }
`;
